var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForwardOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 18V14C5 12.7719 5.77193 12 7 12H20C20.5439 12 21 11.5439 21 11C21 10.4561 20.5439 10 20 10H7C4.78947 10 3 11.7895 3 14V18C3 18.5439 3.45614 19 4 19C4.54386 19 5 18.5439 5 18ZM19.2982 10.2982L14.2982 15.2982C14.1053 15.4737 14 15.7193 14 16C14 16.5439 14.4561 17 15 17C15.2807 17 15.5263 16.8947 15.7018 16.7018L20.7018 11.7018C20.8947 11.5263 21 11.2807 21 11C21 10.4561 20.5439 10 20 10C19.7193 10 19.4737 10.1053 19.2982 10.2982ZM14.2982 6.70176L19.2982 11.7018C19.4737 11.8947 19.7193 12 20 12C20.5439 12 21 11.5439 21 11C21 10.7193 20.8947 10.4737 20.7018 10.2982L15.7018 5.29825C15.5263 5.10526 15.2807 5 15 5C14.4561 5 14 5.45614 14 6C14 6.2807 14.1053 6.52632 14.2982 6.70176Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardOutlined);
export default __webpack_public_path__ + "static/media/forward_outlined.9b8277c1.svg";
export { ForwardRef as ReactComponent };